var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.type == 'button')?_c('button',_vm._g({staticClass:"w-full text-left",class:_vm.classes},_vm.$listeners),[_vm._t("default")],2):_c('router-link',{class:_vm.classes,attrs:{"to":_vm.to}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }